import {
  Component,
  DestroyRef,
  inject,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { LocalizationModel } from '@shared/core';
import { UIModal } from '../../modal.component';
import { UIButton } from '../../../button';
import { UIBaseModal } from '../base-modal.component';
import { LocalizationPipe } from '@shared/modules/localization';
import {
  IConfirmModalButtonOptions,
  IConfirmModalOptions,
} from '../../services';
import { catchError, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ui-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [UIModal, UIButton, LocalizationPipe],
})
export class UIConfirmModal
  extends UIBaseModal
  implements IConfirmModalOptions
{
  @Input() title?: string | LocalizationModel;
  @Input() destription?: string | LocalizationModel;
  @Input() buttonColor?: 'basic' | 'accent' | 'danger';
  @Input() buttons?: IConfirmModalButtonOptions[];
  @Input() onOk?: () => Observable<any>;

  private destroy$ = inject(DestroyRef);

  isConfirming = false;

  onCancel(): void {
    this.onAfterClose();
  }

  onConfirm(onClicked?: () => Observable<any>): void {
    if (this.isConfirming) {
      return;
    }
    this.isConfirming = true;

    if (!this.onOk && !onClicked) {
      this.onAfterClose(true);
      return;
    }

    (onClicked || this.onOk)?.()
      .pipe(
        catchError((error) => {
          this.isConfirming = false;
          throw error;
        }),
        takeUntilDestroyed(this.destroy$)
      )
      .subscribe(() => {
        this.isConfirming = false;
        this.onAfterClose(true);
      });
  }
}
